// extracted by mini-css-extract-plugin
export default {"containerScroll":"cvjpj9s2g","container":"cvl9ae29v","widgetHolder":"cthircj7k"};